import { useTableDictionaries } from '@/creditflowresearch/application/TableDictionaries';
import TruncatedTextCell from './TruncatedTextCell';

interface ITruncatedDictionaryCellProps {
  id: string | null,
  dictionaryKey: string,
}

const TruncatedDictionaryCell = ({ id, dictionaryKey }: ITruncatedDictionaryCellProps) => {
  const dictionaries = useTableDictionaries();

  if (!id) {
    return (<>-</>);
  }

  const accessor = dictionaries[dictionaryKey];
  const item = accessor?.getById(id);

  return (<TruncatedTextCell value={ item?.name ?? id } />);
};

export default TruncatedDictionaryCell;
